import * as React from 'react';
import { PlannerItemThumbnailLoader } from './PlannerItemThumbnailLoader';
import { PlannerItemThumbnailPopper } from './PlannerItemThumbnailPopper';
import { usePlannerItemThumbnail } from './usePlannerItemThumbnail';

type PlannerItemThumbnailInnerContainerProps = {
    anchorEl: HTMLElement | null;
    open: boolean;
    plannerId: string;
};

export function PlannerItemThumbnailInnerContainer({
    anchorEl,
    open,
    plannerId,
}: PlannerItemThumbnailInnerContainerProps) {
    const { loading, thumbnail } = usePlannerItemThumbnail(plannerId);

    if (loading) {
        return <PlannerItemThumbnailLoader />;
    }
    // If no thumbnail is loaded don't show a popper
    if (!thumbnail) {
        return <></>;
    }
    return (
        <PlannerItemThumbnailPopper
            anchorEl={anchorEl}
            open={open}
            thumbnailTitle={thumbnail.title}
            thumbnailUrl={thumbnail.url}
        />
    );
}
PlannerItemThumbnailInnerContainer.displayName = 'PlannerItemThumbnailInnerContainer';
